import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'lime' | 'outline';
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CtaButton({
  children,
  variant = 'primary',
  className = '',
  href,
  onClick
}: CtaButtonProps) {
  const base = 'inline-flex min-h-[52px] items-center justify-center gap-2.5 rounded-full px-7 py-4 text-sm font-extrabold uppercase tracking-wide transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:text-base';
  const styles = {
    primary: 'bg-ink text-snow shadow-[0_10px_26px_rgba(122,30,60,0.12)] hover:bg-ink-soft',
    lime: 'bg-lime text-ink shadow-[0_12px_28px_rgba(122,30,60,0.28)] hover:bg-lime-soft',
    outline: 'border-2 border-lime/70 text-lime hover:border-lime hover:bg-lime/5'
  }[variant];
  if (href) {
    return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-11" data-mp="15arfghgn5fn3">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} className={`${base} ${styles} ${className}`} data-id="element-12" data-mp="35yh8m1z8z44o">
      {children}
    </button>;
}